import React from "react";
import ProductCard from "../components/ProductCard";
import { Col, Container, Row } from "react-bootstrap";

const products = [
  {
    id: 100,
    title: "Chicken Boneless Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 1200,
    imageMain: "./assets/Chicken Boneless Pickle.png",
    images: [
      "./assets/chicken/chicken-1.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 101,
    title: "Chicken Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 800,
    imageMain: "./assets/Chicken Pickle.jpg",
    images: [
      "./assets/Chicken Pickle.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 102,
    title: "Prawn Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 1600,
    imageMain: "./assets/Prawn Pickle.jpg",
    images: [
      "./assets/prawn/prawn-1.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 103,
    title: "Gongura Chicken Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 1000,
    imageMain: "./assets/Gongura Chicken Pickle.jpg",
    images: [
      "./assets/chicken/chicken-2.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 104,
    title: "Gongura Chicken Boneless Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 1400,
    imageMain: "./assets/Gongura Chicken Boneless Pickle.jpg",
    images: [
      "./assets/chicken/chicken-1.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 105,
    title: "Fish Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 1600,
    imageMain: "./assets/Fish Pickle.jpg",
    images: [
      "./assets/fish/fish-1.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 106,
    title: "Mutton Boneless Pickle",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 2500,
    imageMain: "./assets/Mutton Boneless Pickle.jpg",
    images: [
      "./assets/mutton/mutton-1.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
  {
    id: 107,
    title: "Prawn Karam Podi",
    description: "Homemade Trendy Pickle - 1 Kg",
    price: 1000,
    imageMain: "./assets/Prawn Karam Podi.jpg",
    images: [
      "./assets/prawn/prawn-1.jpg",
      "image2.jpg",
      "image3.jpg",
    ],
  },
];

function NonVegMenuPage() {
  return (
    <Container className="mt-4 mb-4">
      <Row>
        {products.map((product) => (
          <Col key={product.id} md={4} className="mt-4 mb-4">
            <ProductCard product={product} />
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default NonVegMenuPage;
